<script>
// import { new_api, free_new_api } from "@/sidebar.vue";
import { new_api } from '../../auth_config.json';
import ReportAssesment from '@/ReportAssesments/index.vue';
import Chatbot from '@/Chatbot/chatbot.vue';
export default {
  name: 'sidebar',
  components: {
    ReportAssesment,
    Chatbot,
  },
  props: {
    stepForm: {
      type: Boolean,
      required: true,
    },
    activeTab: {
      type: Array,
    },
    showPeer: {
      type: Boolean,
      required: true,
    },
    showResult: {
      type: Boolean,
      required: true,
    },
    stepEnable: {
      type: Boolean,
      required: true,
    },
    dataLoading: {
      type: Boolean,
      required: true,
    },
    dark: {
      type: Boolean,
      required: true,
    },
    collapsedChecked: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    dataLoading: {
      handler(value) {
        this.reportLoading = value;
      },
      deep: true,
    },
  },
  data() {
    let token;
    try {
      var cookieArr = document.cookie.split(';');

      // Loop through the array elements
      for (var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split('=');

        /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
        if ('userDetail' == cookiePair[0].trim()) {
          // Decode the cookie value and return
          // console.log(decodeURIComponent(cookiePair[1]));
          token = decodeURIComponent(cookiePair[1]);
        }
      }
    } catch (e) {}

    return {
      old_password: '',
      new_password: '',
      access_token: token,
      peer: this.showPeer,
      isSticky: false,
      stickyClass: 'is_sticky',
      scrollPosition: 0,
      checked: true,
      opened: false,
      modalShow: false,
      data: null,
      buttonOpen: false,
      reportClick: false,
      activateTab: 1,
      reportLoading: true,
      logoRand: Math.floor(Math.random() * 1000 + 1),
      msg: 'Would you like to save the report before you leave? \nIf not, your session data could be lost.',
    };
  },

  async mounted() {
    if (this.$route.query.onboard) {
      this.activateTab = 1;
    }
    if (this.$route.query.mainapp) {
      this.activateTab = 2;
      this.onByPass();
      this.$router.replace({ query: null });
    }
    const storedData = await this.$cookies.get('storedData');
    const userData = await this.$cookies.get('userDetail');
    const assessment = await this.$cookies.get('assessmentId');
    if (storedData && userData && assessment) {
      if (storedData.age && this.activateTab === 1) {
        this.activateTab = 2;
      }
    }

    window.addEventListener('loginEvent', (event) => {
      this.data = event.detail;
    });

    const hash = new URL(window.location.href).hash;
    if (hash && hash.includes('#access_token=')) {
      const token = hash.split('#access_token=')[1];
      try {
        localStorage.setItem('access_token', token);
      } catch (e) {}
      this.access_token = token;
      this.$parent.access_token = token;
      history.replaceState({}, document.title, '.');
    }
    // var hash = window.location.href;
    // console.log(hash,'sasaaa')
    // prevent click outside event with popupItem.
    this.popupItem = this.$el;
  },
  // do not forget this section
  directives: {
    // ClickOutside
  },
  computed: {
    userName() {
      return (
        (this.$cookies.get('userDetail') && this.$cookies.get('userDetail').data
          ? this.$cookies.get('userDetail').data.name
          : null) || this.data
      );
    },
    userId() {
      return (
        (this.$cookies.get('userDetail') && this.$cookies.get('userDetail').data
          ? this.$cookies.get('userDetail').data.id
          : null) || this.data
      );
    },
    getUserId() {
      return (
        (this.$cookies.get('userDetail') && this.$cookies.get('userDetail').data
          ? this.$cookies.get('userDetail').data.id
          : null) || this.data
      );
    },
    userType() {
      return (
        (this.$cookies.get('userDetail') && this.$cookies.get('userDetail').data
          ? this.$cookies.get('userDetail').data.user_type
          : null) || this.data
      );
    },
    userEmail() {
      return (
        (this.$cookies.get('userDetail') && this.$cookies.get('userDetail').data
          ? this.$cookies.get('userDetail').data.email
          : null) || this.data
      );
    },
    getCookies() {
      return (
        (this.$cookies.get('userDetail') && this.$cookies.get('userDetail').data) || this.$cookies.get('userDetail')
      );
    },
  },
  methods: {
    autoFill(data) {
      this.$emit('fillAutoData', data);
      this.openSpendidApp(false);
      this.$emit('stepEnable', false);
      this.$cookies.set('stepEnable', false);
    },
    menuClick(param) {
      // var reportNotSaved = window.localStorage.getItem('saveReport');
      switch (param) {
        case 'profile':
          // window.dispatchEvent(
          //   new CustomEvent("paramClick", {
          //     detail: param,
          //   })
          // );

          window.location.replace('https://biz.spendid.io/user/account');
          break;
        case 'my_saved_report':
          // if(reportNotSaved==='no'){
          //   var result = confirm(this.msg);
          //   if (result) {
          //     this.$parent.saveReport()
          //   }
          // }
          var mainData = {
            stepEnable: true,
          };
          this.$cookies.set('storedData', mainData);
          this.$parent.stepEnable = false;
          this.$cookies.set('stepEnable', false);
          setTimeout(() => {
            this.reportPerticularClick();
            this.activateTab = 3;
          }, 1000);

          break;
        case 'logout':
          this.logoutAll();
          break;
        case 'account':
          // window.dispatchEvent(
          //   new CustomEvent("paramClick", {
          //     detail: param,
          //   })
          // );
          window.location.replace('https://biz.spendid.io/user/account');
          break;
        case 'faq':
          // window.dispatchEvent(
          //   new CustomEvent("paramClick", {
          //     detail: param,
          //   })
          // );
          window.location.replace('https://spendid.io/faqs');
          break;
        case 'contact_us':
          // window.dispatchEvent(
          //   new CustomEvent("paramClick", {
          //     detail: param,
          //   })
          // );
          window.location.replace('https://spendid.io/contact');
          break;
        case 'user_reports':
          // window.dispatchEvent(
          //   new CustomEvent("paramClick", {
          //     detail: param,
          //   })
          // );
          window.location.replace('https://biz.spendid.io/user/child-user-reports');
          break;
        case 'analytics':
          // window.dispatchEvent(
          //   new CustomEvent("paramClick", {
          //     detail: param,
          //   })
          // );
          window.location.replace('https://biz.spendid.io/analytics');
          break;
        case 'users':
          // window.dispatchEvent(
          //   new CustomEvent("paramClick", {
          //     detail: param,
          //   })
          // );
          // if(reportNotSaved==='no' && !this.stepEnable && this.showResult){
          //     var result = confirm(this.msg);
          //     if (result) {
          //       this.$parent.saveReport()
          //     }
          //   }
          window.location.replace('https://biz.spendid.io/user/list');
          break;
        default:
          break;
      }
    },
    uploadFile() {
      const images = this.$refs.file.files[0];
      const formData = new FormData();
      formData.append('company_logo', images);
      formData.append('userId', this.$cookies.get('userDetail').data.id);
      const headers = {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + this.getCookies.access_token,
      };
      this.$http.post(`${free_new_api}/update/company-logo`, formData, { headers }).then((res) => {
        this.logoRand = Math.floor(Math.random() * 1000 + 1);
      });
    },
    openSpendidApp(arg = true) {
      this.outSideClickClose();
      this.$parent.stepEnable = false;
      this.$emit('stepEnable', false);

      this.$cookies.set('stepEnable', false);

      let headers = {
        Authorization: 'Bearer ' + this.getCookies.access_token,
      };
      if (arg) {
        this.$http.get(`${new_api}/get-last-data-By-user`, { headers }).then((response) => {
          this.$emit('fillAutoData', response);
          // location.reload()
        });
      }
      // this.onByPass();
      if (this.activateTab !== 2) {
        this.activateTab = 2;
      }
    },
    reportPerticularClick() {
      this.$router.push({ path: '/', query: { report: 'true' } });
      location.reload();
    },
    outSideClickClose() {
      if (this.reportClick) {
        this.$bvModal.hide('modal-fullscreen');
      }
    },
    onByPass() {
      let headers = {
        Authorization: 'Bearer ' + this.getCookies.access_token,
      };
      this.$http
        .post(
          `${new_api}/report-save`,
          {
            name: 'new Report',
          },
          { headers }
        )
        .then(
          (res) => {
            this.$cookies.set('assessmentId', res.data.reportId);

            this.$http.get(`${new_api}/get-last-data-By-user`, { headers }).then((response) => {
              this.$emit('fillAutoData', response);
              // location.reload()
            });

            // this.$emit('stepEnable', false)
          },
          (response) => {
            if (response.status == 401) {
              this.$cookies.remove('userDetail');
              this.$cookies.remove('storedData');
            }
          }
        );
    },
    changeNow() {
      const user = this.getCookies;
      let headers = {
        Authorization: 'Bearer ' + this.getCookies.access_token,
      };
      this.$http
        .post(
          `${new_api}/change-password`,
          {
            old_password: this.old_password,
            new_password: this.new_password,
            userId: user.id,
          },
          { headers }
        )
        .then((res) => {
          this.old_password = '';
          this.new_password = '';
          this.$bvModal.hide('change-popup');
        })
        .catch((err) => {
          alert(err.response.data.message);
        });
    },
    btnClick() {
      window.open('https://spendid.io');
    },
    logoutAll() {
      // Clear localStorage
      localStorage.removeItem('access_token');

      // List of cookies to remove
      const cookies = ['userDetail', 'storedData', 'dontshow', 'assessmentId'];

      cookies.forEach((name) => {
        // Remove cookie for current path and domain
        document.cookie = `${name}=; Max-Age=0; path=/; domain=${location.hostname}`;
        document.cookie = `${name}=; Max-Age=0; path=/`; // fallback
      });

      // Optional: remove via your cookies plugin (if it works)
      if (typeof this !== 'undefined' && this.$cookies) {
        cookies.forEach((name) => this.$cookies.remove(name, '/', '.spendid.io'));
      }

      // Redirect after 100ms to ensure cookies are cleared
      setTimeout(() => {
        window.location.href = 'https://biz.spendid.io/logout-user-from-app';
      }, 100);
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
    cancel() {
      this.$refs['startover'].hide();
    },
    toggle() {
      this.opened = !this.opened;
    },
    hide() {
      this.opened = false;
    },
    activeTabs(arg) {
      this.$parent[arg] = false;
      this.$parent.validateCheck();
      this.$parent.checkResultToggle();
    },
    handleScroll() {
      this.scrollPosition = window.scrollY;
      if (this.scrollPosition >= 1) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },
    login() {
      this.$auth.loginWithPop();
    },
    // Log the user out
    logout() {
      localStorage.removeItem('access_token');
      location.reload();
      //   this.$auth.logout({
      //     returnTo: window.location.origin
      // });
    },
  },
};
</script>

<template>
  <div class="sidebar-area">
    <b-button class="sidebar-close" @click="$parent.openSidebar = false">X</b-button>
    <div class="user-group-logo">
      <img
        :src="`https://biz.spendid.io/api/get-header-image/${getUserId}?var=${logoRand}`"
        alt="logo"
        class="main-profile-img"
      />
      <!-- <label v-if="userType === 'group-plan' || userType === 'cu-plan'">
                <input
                    type="file"
                    @change="uploadFile"
                    ref="file"
                />
                <div class="img-area">upload user group logo</div>
                <div class="edit-icon">
                    <i class="fas fa-pencil"></i>
                </div>
            </label> -->
    </div>
    <div class="navigation-area">
      <ul>
        <li
          class="menu-section"
          v-if="userType === 'group-plan' || userType === 'cu-plan' || userType === 'gradbudget-school-plan'"
        >
          <h4 class="menu-text">Group Administration</h4>
        </li>
        <li class="menu-item">
          <button
            type="button"
            v-if="userType === 'group-plan' || userType === 'cu-plan' || userType === 'gradbudget-school-plan'"
            @click="
              $parent.stepEnable = false;
              menuClick('users');
              $cookies.set('stepEnable', false);
            "
          >
            <span class="nav-icon"><i class="fas fa-users"></i></span>
            <span class="nav-text">Users</span>
          </button>
        </li>
        <li class="menu-item">
          <button
            type="button"
            v-if="userType === 'group-plan' || userType === 'cu-plan' || userType === 'gradbudget-school-plan'"
            @click="
              $parent.stepEnable = false;
              menuClick('user_reports');
              $cookies.set('stepEnable', false);
            "
          >
            <span class="nav-icon"><i class="fas fa-chart-pie"></i></span> <span class="nav-text">User Reports</span>
          </button>
        </li>

        <li class="menu-section">
          <h4 class="menu-text">App Navigation</h4>
        </li>
        <li class="menu-item">
          <button
            type="button"
            :class="{ active: stepEnable }"
            @click="
              $parent.stepEnable = true;
              $parent.activeTab = [];
              $cookies.set('stepEnable', true);
            "
          >
            <span class="nav-icon"><i class="fas fa-user"></i></span> <span class="nav-text">My Interview</span>
          </button>
        </li>
        <li class="menu-item">
          <button
            type="button"
            :class="{ active: !stepEnable && activeTab.includes('Your Profile') }"
            @click="
              $parent.stepEnable = false;
              $parent.activeTab = ['Your Profile'];
              $parent.scrollToSection('Your Profile');
              $cookies.set('stepEnable', false);
            "
          >
            <span class="nav-icon"><i class="fas fa-user"></i></span> <span class="nav-text">My Profile</span>
          </button>
        </li>
        <li class="menu-item">
          <button
            type="button"
            :class="{ active: activeTab.includes('Income') }"
            @click="
              $parent.stepEnable = false;
              $parent.activeTab = ['Income'];
              $parent.scrollToSection('Income');
              $cookies.set('stepEnable', false);
            "
          >
            <span class="nav-icon"><i class="fas fa-hand-holding-usd"></i></span>
            <span class="nav-text">My Income</span>
          </button>
        </li>
        <li class="menu-item">
          <button
            type="button"
            :class="{
              active:
                activeTab.includes('Your Major Expenses') ||
                activeTab.includes('Common Monthly Bills') ||
                activeTab.includes('Other Discretionary Expenses'),
            }"
            @click="
              $parent.stepEnable = false;
              $parent.activeTab = ['Your Major Expenses'];
              $parent.scrollToSection('Your Major Expenses');
              $cookies.set('stepEnable', false);
            "
          >
            <span class="nav-icon"><i class="fas fa-funnel-dollar"></i></span> <span class="nav-text">My Expenses</span>
          </button>
        </li>
        <li class="menu-item">
          <button
            type="button"
            :class="{ active: activeTab.includes('Your Result') }"
            @click="
              $parent.stepEnable = false;
              $parent.activeTab = ['Your Result'];
              $parent.scrollToSection('Your Result');
              $cookies.set('stepEnable', false);
            "
          >
            <span class="nav-icon"><i class="fas fa-poll"></i></span> <span class="nav-text">My Results</span>
          </button>
        </li>
        <li class="menu-item">
          <button
            type="button"
            @click="
              menuClick('my_saved_report');
              $cookies.set('stepEnable', false);
            "
          >
            <span class="nav-icon"><i class="fas fa-file-pdf"></i></span> <span class="nav-text">My Saved Reports</span>
          </button>
        </li>
        <li class="menu-section">
          <h4 class="menu-text">Other</h4>
        </li>
        <li class="menu-item">
          <button
            type="button"
            @click="
              $parent.stepEnable = false;
              $cookies.set('stepEnable', false);
              menuClick('account');
            "
          >
            <span class="nav-icon"><i class="fas fa-user-circle"></i></span> <span class="nav-text">Account</span>
          </button>
        </li>
        <li class="menu-item">
          <button
            type="button"
            @click="
              $parent.stepEnable = false;
              $cookies.set('stepEnable', false);
              menuClick('logout');
            "
          >
            <span class="nav-icon"><i class="fas fa-sign-out"></i></span> <span class="nav-text">Logout</span>
          </button>
        </li>
        <li class="menu-item">
          <button
            type="button"
            @click="
              $parent.stepEnable = false;
              $cookies.set('stepEnable', false);
              menuClick('faq');
            "
          >
            <span class="nav-icon"><i class="fas fa-question-circle"></i></span> <span class="nav-text">FAQ</span>
          </button>
        </li>
        <li class="menu-item">
          <button
            type="button"
            @click="
              $parent.stepEnable = false;
              $cookies.set('stepEnable', false);
              menuClick('contact_us');
            "
          >
            <span class="nav-icon"><i class="fas fa-envelope"></i></span> <span class="nav-text">Contact Us</span>
          </button>
        </li>
      </ul>
    </div>
    <div class="chatbot-button-outer">
      <Chatbot class="chatbot-button btn-77"></Chatbot>
    </div>
  </div>
</template>

<style>
.chatbot-button-outer {
  width: 210px;
  /* background-color: #292f45;
    border: solid 1px #525b75; */
  background-color: #5828a7;
  border: 1px solid #9043c1;
  position: absolute;
  bottom: 0;
  margin: 10px;
  /* padding: 10px; */
  /* display: flex; */
  /* align-items: center; */
  border-radius: 10px;
  box-sizing: border-box;
}
@media all and (max-width: 991px) {
  .chatbot-button-outer {
    width: 48px;
    height: 48px;
    right: 0;
  }
}
.chatbot-button-outer h4 {
  font-size: 16px;
  color: #d0d2e8;
  font-weight: 600;
  margin-left: 5px;
}
.right-body-part {
  /* padding-left: 232px; */
  padding-left: 0px;
}
.sidebar-area {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 232px;
  /* background: #fff; */
  z-index: 99;
  /* border-right: 1px solid #f6f6fd; */
  box-shadow: rgba(12, 18, 18, 0.1) 0px 1px 1px;
}
.sidebar-area {
  background: #151d32;
  border-color: #525b75;
}
/* .darkmode .sidebar-area{
    background: #151d32;
    border-color: #525B75;
} */
.darkmode .sidebar-area {
  border: solid 1px;
  border-color: #525b75;
}
.user-group-logo {
  height: 120px;
  padding: 4px 10px;
  /* box-shadow: rgba(12, 18, 18, 0.1) 0px 4px 10px; */
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.user-group-logo {
  margin: 10px;
}
.user-group-logo {
  background-color: #f8f8f8;
  border: dotted 2px #afafaf;
}
.darkmode .user-group-logo {
  background-color: #151d32;
  border: 1px solid #525b75;
}
.main-profile-img {
  max-height: 120px;
}

@media all and (min-width: 1580px) {
  .user-group-logo {
    height: 120px;
  }
}
@media all and (min-width: 1200px) {
  .user-group-logo {
    position: fixed;
    left: 0;
    right: 0;
    max-width: 22% !important;
    z-index: 9;
  }
  .user-group-logo {
    margin: 10px 15px;
  }
}
@media all and (min-width: 1400px) {
  .user-group-logo {
    position: fixed;
    left: 0;
    right: 0;
    max-width: 18% !important;
    z-index: 9;
  }
}

/* .user-group-logo{
    border-bottom: solid 1px #525B75;
} */
/* .darkmode .user-group-logo{
    background: #292f45;
    border-bottom: solid 1px #525B75;
} */
.user-group-logo > label {
  background: #fff;
  /* border: 10px solid #D5D7DA; */
  width: 100%;
  max-width: 100px;
  min-width: 100px;
  height: 100px;
  border-radius: 100px;
  margin: auto;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  /* padding: 8px; */
  position: relative;
}
@media all and (min-width: 1580px) {
  .user-group-logo > label {
    max-width: 100px;
    min-width: 100px;
    height: 100px;
  }
}
.user-group-logo > label input {
  display: none;
}
.user-group-logo > label > .img-area {
  width: 100%;
  height: 100%;
  border-radius: 100px;
  border: 1px dashed #2ba195;
  text-transform: uppercase;
  color: #a2a3b7;
  font-size: 12px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  overflow: hidden;
  text-align: center;
  padding: 10px;
  font-weight: 600;
}
@media all and (min-width: 1580px) {
  .user-group-logo > label > .img-area {
    font-size: 13px;
    padding: 2px;
  }
}
.user-group-logo > label > .img-area img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.user-group-logo > label > .edit-icon {
  position: absolute;
  width: 32px;
  height: 32px;
  top: -10px;
  right: -10px;
  border: 1px solid #dedede;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
  background: #fff;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  display: -webkit-flex;
  -webkit-justify-content: center;
  -webkit-align-items: center;
  cursor: pointer;
}
.navigation-area {
  /* padding: 22px 0px; */
  position: absolute;
  top: 134px;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
  height: calc(100vh - 260px);
}
@media all and (min-width: 1580px) {
  .navigation-area {
    top: 166px;
  }
}
.navigation-area ul {
  margin: 0px;
  padding: 0px;
}
.navigation-area ul li {
  margin: 6px 14px;
}
.navigation-area ul li a,
.navigation-area ul li button {
  font-size: 14px;
  color: #c7cbe3;
  font-weight: 600;
  background-color: transparent;
  border: solid 2px transparent;
  display: block;
  text-decoration: none;
  position: relative;
  transition: all 0.3s;
}
.navigation-area ul li button {
  width: 100%;
  text-align: left;
}

.navigation-area ul li a,
.navigation-area ul li button {
  padding: 3px 5px;
}

.navigation-area ul .menu-section .menu-text {
  font-size: 14px;
  transition: all 0.3s;
  color: #ffffff;
  margin-bottom: 0;
  margin-top: 15px;
  margin-bottom: 12px;
}
.navigation-area ul li a:hover,
.navigation-area ul li.active a,
.navigation-area ul li.active a:hover,
.navigation-area ul li button:hover,
.navigation-area ul li.active button,
.navigation-area ul li.active button:hover,
.navigation-area ul li button.active,
.navigation-area ul li button.active:hover {
  background-color: #2ba195;
  color: #fff;
  border-radius: 100px;
  border: solid 2px #2ba195;
}
/* .darkmode .navigation-area ul li a {
    color: #d0d2e8;
    color: #6C7293;
} */
.navigation-area ul li a .nav-icon,
.navigation-area ul li button .nav-icon {
  width: 32px;
  height: 32px;
  background-color: #6c7293;
  transition: all 0.3s;
  color: #c0c0c0;
  padding: 4px;
  border-radius: 100px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 15px;
  font-size: 15px;
  margin-right: 12px;
}
.navigation-area ul li a:hover .nav-icon,
.navigation-area ul li.active a .nav-icon,
.navigation-area ul li button:hover .nav-icon,
.navigation-area ul li.active button .nav-icon,
.navigation-area ul li button.active:hover .nav-icon,
.navigation-area ul li button.active .nav-icon {
  background-color: #257a72;
  transition: all 0.3s;
  color: #ffffff;
}
/* .navigation-area ul li a:hover:after{
    transition: all .5s;
    transform : translateX(-4px);
} */
/* .navigation-area ul li.active a:after{
    content: "";
    position: absolute;
    right: -15px;
    top:3px;
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
    border-right:20px solid #2BA195;
    border-bottom: 8px solid transparent;
} */
/* .navigation-area ul li a:hover:after,
.navigation-area ul li.active a:hover:after{
    transition: all .5s;
    transform : translateX(-4px);
} */
/* .navigation-area ul li:nth-child(2) {
    border-bottom: 1px solid #C8C8C8;
    padding-bottom: 5px;
    margin-bottom: 5px;
}
.navigation-area ul li:nth-last-child(4) {
    border-top: 1px solid #C8C8C8;
    padding-top: 5px;
    margin-top: 5px;
}
.darkmode .navigation-area ul li:nth-last-child(4),
.darkmode .navigation-area ul li:nth-child(2) {
    border-color: #525b75;
} */
</style>
